import React from 'react';
import { connect } from 'react-redux';
import { toast } from 'react-toastify';
import { Collapse, Modal } from 'bootstrap';
import AppBaseComponent from '../../../components/AppBaseComponent';
import HttpAPICall from '../../../services/HttpAPICall';
import { INVENTORY_API_BASE_URL_2, IAM_API_BASE_URL_2 } from '../../../services/TapApiUrls';
import ApplicationLayout from '../../../layouts/ApplicationLayout';
import Loader from '../../../components/ui/Loader/Loader';
import Ax from '../../../components/hoc/Ax';
import TapSelect from '../../../components/ui/TapSelect';
import { DisplayListPagination, DisplaySearchCriteria, PeriodSelectionWithCustom } from '../../../components/TapUi';
import InputCustomerSearch from '../../includes/ui/InputCustomerSearch';
import InputDealSearch from '../../../pages/salesCrm/includes/InputDealSearch';
import CustomerProjectSearch from '../../../pages/salesCrm/includes/CustomerProjectSearch';
import InputItemSearch from '../../includes/ui/InputItemSearch';
import InputAssetSearch from '../../includes/ui/InputAssetSearch';
import InputWorkstationSearch from '../../includes/ui/InputWorkstationSearch';
import InputEmployeeSearch from '../../includes/ui/InputEmployeeSearch';
import InputSubAssemblySearch from '../../includes/ui/InputSubAssemblySearch';
import SalesOrderDetail from '../../salesCrm/salesOrder/SalesOrderDetail';
import DateService from '../../../services/DateService';
import CurrencyFormatter from '../../../services/CurrencyFormatter';
import TapIcon from '../../../services/TapIcon';
import { Helmet } from 'react-helmet';
import AssetHeader from '../includes/AssetHeader';
import AssetDetailHorizontalCard from '../includes/AssetDetailHorizontalCard';
import { Link } from 'react-router-dom';
import moment from 'moment';

class AssetSalesOrder extends AppBaseComponent {
    constructor(props) {
        super(props);

        this.initQuoteSearchForm = {
            search_transaction_id: '',
            search_customer_ids: [],
            search_customer_project_ids: [],
            search_warehouse_ids: [],
            date_range: null,
            date_range_start: null,
            date_range_end: null,
            search_item_ids: [],
            search_item_tags: [],
            search_status_ids: [],
            search_priority: '',
            tagged_user_ids: [],
            search_deal_ids: [],
            search_asset_ids: [],
            search_workstation_ids: [],
            search_employee_ids: [],
            search_sub_assembly_ids: [],
            search_so_for: '',
        };

        this.quoteSearchFormLabel = {
            search_transaction_id: 'Transaction ID : ',
            search_warehouse_ids: 'Warehouses : ',
            search_so_for: 'Sales Order For : ',
            search_asset_ids: 'Assets : ',
            search_workstation_ids: 'Workstations : ',
            search_sub_assembly_ids: 'Sub Assemblies : ',
            search_employee_ids: 'Employees : ',
            date_range: 'Date Range : ',
            search_item_ids: 'Items : ',
            search_item_tags: 'Item Tags : ',
            search_status_ids: 'Search Status : ',
            search_priority: 'Search Priority : ',
            search_customer_ids: 'Customer : ',
            search_customer_project_ids: 'Customer Project : ',
            tagged_user_ids: 'Tagged Users : ',
            search_deal_ids: 'Deals : ',
        };

        this.state = {
            access_token: '',
            assetDetail: null,
            asset_loading: false,
            assetId: null,
            listing_loading: false,
            listing_tbl_page: 1,
            quote_listing: [],
            listingMeta: null,
            totalListingCount: 0,
            allItemTags: [],
            quoteSearchForm: { ...this.initQuoteSearchForm },
            submittedPOFilterForm: { ...this.initQuoteSearchForm },
            quoteSearchFormDataLoaded: false,
            all_warehouses: [],
            all_periods: [],
            searchedItem: [],
            searchedCustomer: [],
            searchedCustomerProject: [],
            searchedDeals: [],
            searchedAssets: [],
            searchedWorkstation: [],
            searchedEmployees: [],
            searchedSubassembly: [],
            listingCustomers: [],
            listingStatuses: [],
            listingWarehouses: [],
            formSearchedElems: [],
            minimizeTable: false,
            detail_loading: false,
            salesOrderDetail: null,
            salesOrderTransId: null,
            allStatusOptions: [],
            allPriorityOptions: [],
            allAllowedStatus: [],
            allUsers: [],
            allForOptions: [],
            pdfDownloading: false,
        };

        this.salesOrderListUrl = INVENTORY_API_BASE_URL_2 + '/sales_order/list';
        this.searchFormDataUrl = INVENTORY_API_BASE_URL_2 + '/sales_order/form_data';
        this.salesOrderDetailUrl = INVENTORY_API_BASE_URL_2 + '/sales_order/detail';
        this.salesOrderUrl = INVENTORY_API_BASE_URL_2 + '/sales_order';
    }

    componentDidMount = () => {
        this.initializeData(this.props);
        this.getQuoteSearchFormData();
        this.quoteSearchModal = new Modal(document.getElementById('quoteSearchModal'), { keyboard: false, backdrop: false });
    };

    componentDidUpdate(prevProps) {
        if (prevProps.match.params.id !== this.props.match.params.id) {
            this.initializeData(this.props);
        }
        if (prevProps.all_periods !== this.props.all_periods) {
            this.initializeData(this.props);
        }
    }

    initializeData = (props) => {
        const assetId = props.match?.params?.id;
        let all_periods = [...props.all_periods, { key: 'custom', display: 'Custom Date Range' }];
        this.setState({
            assetId,
            all_warehouses: props.all_warehouses ? props.all_warehouses.map((m) => ({ value: m.id, label: `${m.name} (${m.code})` })) : [],
            all_periods,
            allForOptions: [
                { value: 'asset', label: 'Asset' },
                { value: 'workstation', label: 'Workstation' },
                { value: 'employee', label: 'Employee' },
                { value: 'sub_assembly', label: 'Sub Assembly' },
            ],
            allItemTags: props.item_tags && props.item_tags.length > 0 ? props.item_tags.map((s) => ({ value: s.id, label: s.name })) : [],
        }, () => {
            if (assetId) {
                this.getAssetDetails(assetId);
            }
            this.loadListingTblData(1);
        });
    };

    getAssetDetails = (id) => {
        let assetId = id || this.state.assetId;
        if (!assetId) {
            return;
        }
        this.setState({ asset_loading: true });
        HttpAPICall.withAthorization('GET', IAM_API_BASE_URL_2 + '/asset/' + assetId, this.props.access_token, {}, {}, (response) => {
            this.setState({ assetDetail: response.data.data });
        }, (error) => {
            toast.error(error?.msg, { position: toast.POSITION.TOP_RIGHT });
        }).then(() => this.setState({ asset_loading: false }));
    };

    loadListingTblData = (page = 1) => {
        this.setState({ listing_loading: true, listing_tbl_page: page });
        const assetId = this.state.assetId || this.props.match?.params?.id;
        let params = { ...this.state.submittedPOFilterForm, page };
        if (assetId) {
            params.search_asset_ids = [assetId];
        }
        HttpAPICall.withAthorization('GET', this.salesOrderListUrl, this.props.access_token, params, {}, (resp) => {
            let respData = resp.data;
            let listData = respData?.list || {};
            let listRows = Array.isArray(listData?.data) ? listData.data : (Array.isArray(respData?.data) ? respData.data : []);
            let listingMeta = {
                from: listData?.from ?? respData?.from ?? 0,
                to: listData?.to ?? respData?.to ?? 0,
                total: listData?.total ?? respData?.total ?? 0,
                last_page: listData?.last_page ?? respData?.last_page ?? 0,
                per_page: listData?.per_page ?? respData?.per_page ?? 0,
                current_page: listData?.current_page ?? respData?.current_page ?? page,
            };
            this.setState({
                quote_listing: listRows,
                listingMeta,
                totalListingCount: listingMeta.total,
                listingCustomers: Array.isArray(respData?.customers) ? respData.customers : [],
                listingStatuses: Array.isArray(respData?.status) ? respData.status : [],
                listingWarehouses: Array.isArray(respData?.warehouses) ? respData.warehouses : [],
            });
        }).then(() => this.setState({ listing_loading: false }));
    };

    getListingStatusName = (item) => {
        if (item?.status?.name) {
            return item.status.name;
        }
        let statusId = item?.status_id ?? item?.status;
        if (!statusId) {
            return '-';
        }
        return this.state.listingStatuses.find((s) => s.id == statusId)?.name || '-';
    }

    getListingWarehouseName = (item) => {
        if (item?.warehouse?.name) {
            return item.warehouse.name;
        }
        let warehouseId = item?.warehouse_id ?? item?.warehouse;
        if (!warehouseId) {
            return '-';
        }
        return this.state.listingWarehouses.find((w) => w.id == warehouseId)?.name || '-';
    }

    getListingCustomerName = (item) => {
        if (item?.customer?.name) {
            return item.customer.name;
        }
        let customerId = item?.customer_id ?? item?.customer;
        if (!customerId) {
            return '-';
        }
        return this.state.listingCustomers.find((c) => c.id == customerId)?.name || '-';
    }

    submitPOSearchForm = (e) => {
        e && e.preventDefault();
        let serachFormKeys = Object.keys(this.state.quoteSearchForm);
        let searchedElems = [];
        let searchParams = {};
        serachFormKeys.map((key) => {
            let label = this.quoteSearchFormLabel[key];
            let value = this.state.quoteSearchForm[key];
            if (value && value.toString().length > 0) {
                searchParams[key] = value;
                if (label) {
                    let show_val = value;
                    if (key == 'search_transaction_id') {
                        show_val = this.state.quoteSearchForm.search_transaction_id;
                    }
                    if (key == 'search_so_for') {
                        show_val = this.state.allForOptions.find((s) => s.value === value)?.label || value;
                    }
                    if (key == 'search_customer_ids') {
                        show_val = this.state.searchedCustomer ? this.state.searchedCustomer.map((s) => s.display_label).join(', ') : '';
                    }
                    if (key == 'search_customer_project_ids') {
                        show_val = this.state.searchedCustomerProject ? this.state.searchedCustomerProject.map((s) => s.display_label).join(', ') : '';
                    }
                    if (key == 'search_deal_ids') {
                        show_val = this.state.searchedDeals ? this.state.searchedDeals.map((s) => s.display_label).join(', ') : '';
                    }
                    if (key == 'search_warehouse_ids') {
                        show_val = this.state.all_warehouses.filter((s) => value.includes(s.value)).map((s) => s.label).join(', ');
                    }
                    if (key == 'search_asset_ids') {
                        show_val = this.state.searchedAssets ? this.state.searchedAssets.map((s) => s.display_label).join(', ') : '';
                    }
                    if (key == 'search_workstation_ids') {
                        show_val = this.state.searchedWorkstation ? this.state.searchedWorkstation.map((s) => s.label || s.name || '').join(', ') : '';
                    }
                    if (key == 'search_employee_ids') {
                        show_val = this.state.searchedEmployees ? this.state.searchedEmployees.map((s) => s.label || s.display_label || '').join(', ') : '';
                    }
                    if (key == 'search_sub_assembly_ids') {
                        show_val = this.state.searchedSubassembly ? this.state.searchedSubassembly.map((s) => s.label || s.display_label || '').join(', ') : '';
                    }
                    if (key == 'search_item_ids') {
                        show_val = this.state.searchedItem ? this.state.searchedItem.map((s) => s.display_label).join(', ') : '';
                    }
                    if (key == 'search_item_tags') {
                        show_val = this.state.allItemTags.filter((s) => value.includes(s.value)).map((s) => s.label).join(', ');
                    }
                    if (key == 'search_status_ids') {
                        show_val = this.state.allStatusOptions.filter((s) => value.includes(s.value)).map((s) => s.label).join(', ');
                    }
                    if (key == 'search_priority') {
                        show_val = this.state.allPriorityOptions.filter((s) => value.includes(s.value)).map((s) => s.label).join(', ');
                    }
                    if (key == 'tagged_user_ids') {
                        show_val = this.state.allUsers.filter((s) => value.includes(s.value)).map((s) => s.label).join(', ');
                    }
                    if (key == 'date_range') {
                        let start_range = moment(this.state.quoteSearchForm.date_range_start).format('DD-MMM-YYYY');
                        let end_range = moment(this.state.quoteSearchForm.date_range_end).format('DD-MMM-YYYY');
                        let display_custom = `Custom Date Range (${start_range} - ${end_range})`;
                        show_val = this.state.all_periods.filter((s) => value.includes(s.key)).map((s) => s.display_with_date ? s.display_with_date : display_custom);
                    }
                    searchedElems.push(label + `<b>${show_val}</b>`);
                }
            }
        });
        this.setState({
            submittedPOFilterForm: { ...searchParams },
            formSearchedElems: searchedElems,
        }, () => {
            this.quoteSearchModal.hide();
            this.loadListingTblData(1);
        });
    };

    poSearchClear = () => {
        this.setState({
            formSearchedElems: [],
            quoteSearchForm: { ...this.initQuoteSearchForm },
            submittedPOFilterForm: { ...this.initQuoteSearchForm },
            searchedItem: [],
            searchedCustomer: [],
            searchedCustomerProject: [],
            searchedDeals: [],
            searchedAssets: [],
            searchedWorkstation: [],
            searchedEmployees: [],
            searchedSubassembly: [],
        }, () => {
            this.loadListingTblData(1);
            this.quoteSearchModal.hide();
        });
    };

    quoteSearchModalInit = () => {
        this.getQuoteSearchFormData();
        this.quoteSearchModal.show();
    };

    getQuoteSearchFormData = () => {
        if (!this.state.quoteSearchFormDataLoaded) {
            HttpAPICall.withAthorization('GET', this.searchFormDataUrl, this.props.access_token, null, null, (response) => {
                let formData = response.data;
                this.setState({
                    quoteSearchFormDataLoaded: true,
                    allStatusOptions: formData && formData.status ? formData.status.map((s) => ({ value: s.id, label: s.name })) : [],
                    allPriorityOptions: formData && formData.priorities ? formData.priorities.map((s) => ({ value: s.key, label: s.name })) : [],
                    allUsers: formData && formData.users ? formData.users.map((s) => ({ value: s.id, label: s.full_name, site_ids: s.linked_sites })) : [],
                });
            });
        }
    };

    viewSalesOrderDetail = (transaction_id) => {
        this.setState({ minimizeTable: true });
        if (transaction_id !== this.state.salesOrderTransId) {
            this.getSalesOrderDetail(transaction_id);
        }
    };

    getSalesOrderDetail = (transaction_id) => {
        this.setState({ detail_loading: true });
        HttpAPICall.withAthorization('GET', this.salesOrderDetailUrl + '/' + transaction_id, this.props.access_token, null, {}, (resp) => {
            let respData = resp.data;
            this.setState({
                salesOrderDetail: respData,
                salesOrderTransId: respData.transaction_id,
            });
        }, (err) => {
            if (err) {
                this.setState({ minimizeTable: false });
            }
        }).then(() => this.setState({ detail_loading: false }));
    };

    closeViewDetails = () => {
        this.setState({ minimizeTable: false });
    };

    assetCardHandler = (collapse = true) => {
        new Collapse(document.getElementById('assetCard'));
        if (document.getElementById('pageTbl')) {
            document.getElementById('pageTbl').scroll({ top: 0, behavior: 'smooth' });
        }
    }

    pageTitleBarJsx = () => {
        return (<div className="page_title row m0">
            <div className="col-12 asset_collapse">
                <h3>{this.state?.assetDetail?.name}</h3>
                <AssetHeader assetDetail={this.state.assetDetail} afterChangeStatus={this.getAssetDetails} parentProps={this.props} />
            </div>
        </div>);
    }

    horizontalAssetCardJsx = () => {
        return (
            <div>
                <div id="assetCard" className="collapse pr-1 mt-1" aria-expanded="true">
                    {this.state.asset_loading ? <div className="text-center pt-1"><Loader /></div>
                        : <AssetDetailHorizontalCard assetDetail={this.state.assetDetail} />}
                </div>
            </div>
        );
    };

    SalesOrderListJsx = () => {
        return (
            <Ax>
                <div style={{ paddingTop: '4px' }}>
                    <div className="page_title row m0" style={{ height: '45px' }}>
                        <div className={this.state.minimizeTable ? 'col-sm-3' : 'col-sm-6'}>
                            <h3 style={{ paddingTop: '13px' }}>Sales Order</h3>
                        </div>
                        {!this.state.minimizeTable
                            ? <div className='col-sm-2'>
                                <button type="button" className="btn btn-primary btn-sm" role="button" onClick={this.assetCardHandler}>Asset Card</button>
                            </div>
                            : null}
                        {!this.state.minimizeTable
                            ? <div className='col-sm-4 text-end mt7'>
                                <button type="button" disabled={this.state.listing_loading} onClick={this.quoteSearchModalInit} className="btn btn-secondary">
                                    <TapIcon.imageIcon icon={TapIcon.SearchIcon} className="img-fluid" alt="item-action" />
                                </button>
                               
                            </div>
                            : null}
                        {this.state.minimizeTable
                            ? (
                                <Ax>
                                    <div className="col-sm-3 tap_border_left">
                                        <h3 style={{ paddingTop: '13px' }}>Sales Order : {this.state.salesOrderTransId || '-'}</h3>
                                    </div>
                                    <div className='col-sm-2'>
                                        <button type="button" className="btn btn-primary btn-sm" role="button" onClick={this.assetCardHandler}>Asset Card</button>
                                    </div>
                                    <div className='col-sm-4 text-end mt7'>
                                        <button onClick={this.closeViewDetails} type="button" className="btn btn-secondary">
                                            <TapIcon.imageIcon icon={TapIcon.CloseIcon} className="img-fluid" alt="item-close" />
                                        </button>
                                    </div>
                                </Ax>
                            )
                            : null}
                    </div>
                </div>
                <div className="container-fluid pl0 pr13">
                    <div className="page_containt row">
                        <div className={['pl16', this.state.minimizeTable ? 'col-3 mr0 pr0 wd26' : 'col-12 pr0'].join(' ')}>{this.SalesOrderListingJsx()}</div>
                        {this.state.minimizeTable ? <div className="col-9 pr4 wd74 pl0 pageTbl bg-white">{this.salesOrderViewDetails()}</div> : null}
                    </div>
                </div>
            </Ax>
        );
    };

    SalesOrderListingJsx = () => {
        return (
            <Ax>
                <div className="sticky-top bg-white" ref={this.criteriaRef}>
                    <DisplaySearchCriteria searchedElems={this.state.formSearchedElems} onClearFilter={this.poSearchClear} />
                </div>
                <table className="table table-bordered bg-white">
                    <thead className="table-secondary">
                        {this.state.minimizeTable ? (
                            <tr>
                                <th scope="col" style={{ width: '15%' }}>Transaction ID (Date)</th>
                            </tr>
                        ) : (
                            <tr className="text-center">
                                <th scope="col" style={{ width: '5%' }}>S.No</th>
                                <th scope="col" style={{ width: '12%' }}>Sales Order ID</th>
                                <th scope="col" style={{ width: '12%' }}>Date</th>
                                <th scope="col" style={{ width: '15%' }}>Warehouse</th>
                                <th scope="col" style={{ width: '15%' }}>Customer</th>
                                <th scope="col" style={{ width: '6%' }}>Currency</th>
                                <th scope="col" style={{ width: '10%' }}>Amount</th>
                                <th scope="col" style={{ width: '10%' }}>Status</th>
                                <th scope="col" style={{ width: '5%' }}>Action</th>
                            </tr>
                        )}
                    </thead>
                    <tbody>
                        {this.state.listing_loading ? (
                            <tr><td colSpan="9"><Loader /></td></tr>
                        ) : (this.state.quote_listing?.length > 0 ? this.state.quote_listing.map((item, index) => (
                            <tr key={index}>
                                {this.state.minimizeTable ? (
                                    <Ax>
                                        <td>
                                            <a role="button" className="link-primary" onClick={() => this.viewSalesOrderDetail(item.transaction_id)}>{item.transaction_id}</a>
                                            <br />
                                            <small>{item.transaction_date ? DateService.dateTimeFormat(item.transaction_date, 'DD-MMM-YYYY') : ''}</small>
                                            <small style={{ float: 'right' }}>{this.getListingStatusName(item)}</small>
                                        </td>
                                    </Ax>
                                ) : (
                                    <Ax>
                                        <td>{this.state.listingMeta ? this.state.listingMeta.from + index : index}</td>
                                        <td><a role="button" className="link-primary text-center" onClick={() => this.viewSalesOrderDetail(item.transaction_id)}>{item.transaction_id}</a></td>
                                        <td>{item.transaction_date ? DateService.dateTimeFormat(item.transaction_date, 'DD-MMM-YYYY') : ''}</td>
                                        <td className='text-capitalize'>{this.getListingWarehouseName(item)}</td>
                                        <td className='text-capitalize'>{this.getListingCustomerName(item)}</td>
                                        <td className="text-center">{item.currency ? item.currency : 'INR'}</td>
                                        <td className="text-end"><CurrencyFormatter currencyCode={item.currency ? item.currency : 'INR'} amount={parseFloat(item.total_amount_vc ? item.total_amount_vc : 0).toFixed(2)} /></td>
                                        <td className='text-center'>{this.getListingStatusName(item)}</td>
                                        <td className="text-center">
                                            <button type="button" className="btn" onClick={() => this.viewSalesOrderDetail(item.transaction_id)}>
                                                <TapIcon.FontAwesomeIcon icon={TapIcon.faEllipsisV} />
                                            </button>
                                        </td>
                                    </Ax>
                                )}
                            </tr>
                        )) : (
                            <tr><td colSpan="10" className="text-center">No Records</td></tr>
                        ))}
                    </tbody>
                </table>
                <DisplayListPagination
                    meta={this.state.listingMeta}
                    onPageChange={(e) => this.loadListingTblData(e.selected + 1)}
                />
            </Ax>
        );
    };

    salesOrderViewDetails = () => {
        return (
            <div className='p-2'>
                {!this.state.detail_loading ? (
                    <Ax>
                        {this.state.salesOrderDetail ? <SalesOrderDetail salesOrderDetail={this.state.salesOrderDetail} checkAllItem={this.checkAllItem} /> : <div>No sales order selected.</div>}
                    </Ax>
                ) : <Loader />}
            </div>
        );
    };

    quoteSearchModalJsx = () => {
        const search_so_for = this.state?.quoteSearchForm?.search_so_for;
        return (
            <div className="modal fade" id="quoteSearchModal" tabIndex="-1">
                <div className="modal-dialog modal-lg">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title" id="searchAssetModalLabel">Sales Order Search</h5>
                            <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close" onClick={this.poSearchClear}></button>
                        </div>
                        <form id="quoteSearchForm" onSubmit={this.submitPOSearchForm}>
                            <div className="modal-body">
                                {!this.state.quoteSearchFormDataLoaded ? <Loader /> : (
                                    <Ax>
                                        <div className="row my-3 align-items-center">
                                            <label className="col-sm-2 col-form-label col-form-label-sm">Sales Order Number</label>
                                            <div className="col-sm-10">
                                                <input
                                                    name="search_transaction_id"
                                                    type="text"
                                                    value={this.state.quoteSearchForm?.search_transaction_id}
                                                    className="form-control"
                                                    autoComplete="off"
                                                    onChange={(e) => this.formInputHandler(e, 'quoteSearchForm')}
                                                    placeholder="Please enter Transaction ID"
                                                    style={{ height: '30px', fontSize: '93%' }}
                                                />
                                            </div>
                                        </div>
                                        <div className="row my-3 align-items-center">
                                            <label className="col-sm-2 col-form-label col-form-label-sm">Status</label>
                                            <div className="col-sm-4">
                                                <TapSelect
                                                    options={this.state.allStatusOptions}
                                                    changeEvent={(selectedOption) => this.tapSelectChange(selectedOption, 'quoteSearchForm', 'search_status_ids')}
                                                    isSearchable={true}
                                                    isClearable={true}
                                                    isMulti={true}
                                                    value={this.state.allStatusOptions.filter((s) => this.state.quoteSearchForm?.search_status_ids?.includes(s.value))}
                                                    placeholder="Select Status"
                                                    containerHeight="30px"
                                                    fontSize="93%"
                                                />
                                            </div>
                                            <label className="col-sm-2 col-form-label col-form-label-sm">Priority</label>
                                            <div className="col-sm-4">
                                                <TapSelect
                                                    options={this.state.allPriorityOptions}
                                                    changeEvent={(selectedOption) => this.tapSelectChange(selectedOption, 'quoteSearchForm', 'search_priority')}
                                                    value={this.state.allPriorityOptions.find((u) => u.value == this.state.quoteSearchForm?.search_priority)}
                                                    isSearchable={true}
                                                    isClearable={true}
                                                    placeholder="Select Priority"
                                                    containerHeight="30px"
                                                    fontSize="93%"
                                                />
                                            </div>
                                        </div>
                                        <div className="row my-3 align-items-center">
                                            <label className="col-sm-2 col-form-label col-form-label-sm">Warehouse</label>
                                            <div className="col-sm-10">
                                                <TapSelect
                                                    options={this.state.all_warehouses}
                                                    changeEvent={(selectedOption) => this.tapSelectChange(selectedOption, 'quoteSearchForm', 'search_warehouse_ids')}
                                                    value={this.state.all_warehouses.filter((u) => this.state.quoteSearchForm?.search_warehouse_ids?.includes(u.value))}
                                                    isSearchable={true}
                                                    isMulti={true}
                                                    isClearable={true}
                                                    placeholder="Select Warehouses"
                                                    containerHeight="30px"
                                                    fontSize="93%"
                                                />
                                            </div>
                                        </div>
                                        <div className="row my-3 align-items-center">
                                            <label className="col-sm-2 col-form-label col-form-label-sm">Customer</label>
                                            <div className="col-sm-10">
                                                <InputCustomerSearch
                                                    changeEvent={(selectedOption) => {
                                                        this.tapSelectChange(selectedOption, 'quoteSearchForm', 'search_customer_ids');
                                                        this.setState({ searchedCustomer: selectedOption && selectedOption.length > 0 ? selectedOption : [] });
                                                    }}
                                                    isMulti={true}
                                                    value={this.state?.searchedCustomer?.length > 0 ? this.state.searchedCustomer.map((a) => { a.label = a.display_label; return a; }) : []}
                                                    containerHeight="30px"
                                                    fontSize="93%"
                                                />
                                            </div>
                                        </div>
                                        <div className="row my-3 align-items-center">
                                            <label className="col-sm-2 col-form-label col-form-label-sm">Customer Project</label>
                                            <div className="col-sm-10">
                                                <CustomerProjectSearch
                                                    changeEvent={(selectedOption) => {
                                                        this.tapSelectChange(selectedOption, 'quoteSearchForm', 'search_customer_project_ids');
                                                        this.setState({ searchedCustomerProject: selectedOption && selectedOption.length > 0 ? selectedOption : [] });
                                                    }}
                                                    isMulti={true}
                                                    value={this.state?.searchedCustomerProject?.length > 0 ? this.state.searchedCustomerProject.map((a) => { a.label = a.display_label; return a; }) : []}
                                                    containerHeight="30px"
                                                    fontSize="93%"
                                                />
                                            </div>
                                        </div>
                                        <div className="row my-3 align-items-center">
                                            <label className="col-sm-2 col-form-label col-form-label-sm">Deals</label>
                                            <div className="col-sm-10">
                                                <InputDealSearch
                                                    changeEvent={(selectedOption) => {
                                                        this.tapSelectChange(selectedOption, 'quoteSearchForm', 'search_deal_ids');
                                                        this.setState({ searchedDeals: selectedOption && selectedOption.length > 0 ? selectedOption : [] });
                                                    }}
                                                    isMulti={true}
                                                    value={this.state?.searchedDeals?.length > 0 ? this.state.searchedDeals.map((a) => { a.label = a.display_label; return a; }) : []}
                                                    containerHeight="30px"
                                                    fontSize="93%"
                                                    showSearch={false}
                                                />
                                            </div>
                                        </div>
                                        <div className="row my-3 align-items-center">
                                            <label className="col-sm-2 col-form-label col-form-label-sm">Sales Order For</label>
                                            <div className="col-sm-10">
                                                <TapSelect
                                                    changeEvent={(selectedOption) => {
                                                        this.tapSelectChange(selectedOption, 'quoteSearchForm', 'search_so_for', () => {
                                                            this.setState({
                                                                searchedAssets: [],
                                                                searchedEmployees: [],
                                                                searchedSubassembly: [],
                                                                searchedWorkstation: [],
                                                                quoteSearchForm: {
                                                                    ...this.state.quoteSearchForm,
                                                                    search_asset_ids: [],
                                                                    search_employee_ids: [],
                                                                    search_workstation_ids: [],
                                                                    search_sub_assembly_ids: [],
                                                                    search_customer_ids: [],
                                                                },
                                                            });
                                                        });
                                                    }}
                                                    options={this.state.allForOptions}
                                                    isSearchable={true}
                                                    isClearable={true}
                                                    containerHeight="30px"
                                                    fontSize="93%"
                                                    value={this.state.allForOptions.find((s) => s.value === search_so_for)}
                                                    placeholder="Select Sales Order For"
                                                />
                                            </div>
                                        </div>
                                        {search_so_for ? (
                                            <div className="row my-3 align-items-center">
                                                <label className="col-sm-2 col-form-label col-form-label-sm">
                                                    {this.state.allForOptions.find((s) => s.value == search_so_for)?.label}
                                                </label>
                                                <div className="col-sm-10">
                                                    {search_so_for == 'asset' ? (
                                                        <InputAssetSearch
                                                            changeEvent={(selectedOption) => {
                                                                this.tapSelectChange(selectedOption, 'quoteSearchForm', 'search_asset_ids');
                                                                this.setState({ searchedAssets: selectedOption && selectedOption.length > 0 ? selectedOption : [] });
                                                            }}
                                                            placeholder="Search Asset"
                                                            isMulti={true}
                                                            containerHeight="30px"
                                                            fontSize="93%"
                                                            value={this.state.searchedAssets.length > 0 ? this.state.searchedAssets.map((a) => { a.label = a.display_label; return a; }) : []}
                                                        />
                                                    ) : search_so_for == 'workstation' ? (
                                                        <InputWorkstationSearch
                                                            placeholder="Search Workstation"
                                                            changeEvent={(selectedOption) => {
                                                                this.tapSelectChange(selectedOption, 'quoteSearchForm', 'search_workstation_ids');
                                                                this.setState({ searchedWorkstation: selectedOption && selectedOption.length > 0 ? selectedOption : [] });
                                                            }}
                                                            menuPlacement="top"
                                                            isMulti={true}
                                                            value={this.state.searchedWorkstation.length > 0 ? this.state.searchedWorkstation.map((w) => w) : []}
                                                            containerHeight="30px"
                                                            fontSize="93%"
                                                        />
                                                    ) : search_so_for == 'employee' ? (
                                                        <InputEmployeeSearch
                                                            placeholder="Please Select Employee"
                                                            changeEvent={(selectedOption) => {
                                                                this.tapSelectChange(selectedOption, 'quoteSearchForm', 'search_employee_ids');
                                                                this.setState({ searchedEmployees: selectedOption && selectedOption.length > 0 ? selectedOption : [] });
                                                            }}
                                                            isMulti={true}
                                                            containerHeight="30px"
                                                            fontSize="93%"
                                                            value={this.state.searchedEmployees.length > 0 ? this.state.searchedEmployees.map((a) => { a.label = a.label; return a; }) : []}
                                                        />
                                                    ) : search_so_for == 'sub_assembly' ? (
                                                        <InputSubAssemblySearch
                                                            changeEvent={(selectedOption) => {
                                                                this.tapSelectChange(selectedOption, 'quoteSearchForm', 'search_sub_assembly_ids');
                                                                this.setState({ searchedSubassembly: selectedOption && selectedOption.length > 0 ? selectedOption : [] });
                                                            }}
                                                            placeholder="Search Sub Assembly"
                                                            isMulti={true}
                                                            containerHeight="30px"
                                                            fontSize="93%"
                                                            value={this.state.searchedSubassembly.length > 0 ? this.state.searchedSubassembly.map((a) => { a.label = a.label; return a; }) : []}
                                                        />
                                                    ) : null}
                                                </div>
                                            </div>
                                        ) : null}
                                        <div className="row my-3 align-items-center">
                                            <label className="col-sm-2 col-form-label col-form-label-sm">Item</label>
                                            <div className="col-sm-10">
                                                <InputItemSearch
                                                    placeholder="Search Item"
                                                    isMulti={true}
                                                    changeEvent={(selectedOption) => {
                                                        this.tapSelectChange(selectedOption, 'quoteSearchForm', 'search_item_ids');
                                                        this.setState({ searchedItem: selectedOption ? selectedOption : null });
                                                    }}
                                                    containerHeight="30px"
                                                    fontSize="93%"
                                                    value={this.state?.searchedItem?.length > 0 ? this.state.searchedItem.map((a) => { a.label = a.display_label; return a; }) : []}
                                                />
                                            </div>
                                        </div>
                                        <div className="row my-3 align-items-center">
                                            <label className="col-sm-2 col-form-label col-form-label-sm">Item Tags</label>
                                            <div className="col-sm-10">
                                                <TapSelect
                                                    options={this.state.allItemTags}
                                                    changeEvent={(selectedOption) => this.tapSelectChange(selectedOption, 'quoteSearchForm', 'search_item_tags')}
                                                    value={this.state?.allItemTags.filter((u) => this.state.quoteSearchForm?.search_item_tags?.includes(u.value))}
                                                    isSearchable={true}
                                                    isMulti={true}
                                                    isClearable={true}
                                                    placeholder="Select Item Tags"
                                                    containerHeight="30px"
                                                    fontSize="93%"
                                                />
                                            </div>
                                        </div>
                                        <div className="row my-3 align-items-center">
                                            <label className="col-sm-2 col-form-label col-form-label-sm">Tagged User</label>
                                            <div className="col-sm-10">
                                                <TapSelect
                                                    isSearchable={true}
                                                    isClearable={true}
                                                    isMulti={true}
                                                    placeholder="Tagged User"
                                                    containerHeight="30px"
                                                    fontSize="93%"
                                                    options={this.state.allUsers}
                                                    value={this.state.allUsers.filter((s) => this.state.quoteSearchForm?.tagged_user_ids?.includes(s.value))}
                                                    changeEvent={(selectedOption) => this.tapSelectChange(selectedOption, 'quoteSearchForm', 'tagged_user_ids')}
                                                />
                                            </div>
                                        </div>
                                        <div className="row my-3 align-items-center">
                                            <label className="col-sm-2 col-form-label col-form-label-sm">Transaction Period</label>
                                            <div className="col-sm-10">
                                                <PeriodSelectionWithCustom
                                                    periods={this.state.all_periods ? this.state.all_periods : []}
                                                    value={this.state.quoteSearchForm?.date_range}
                                                    startDate={this.state.quoteSearchForm?.date_range_start}
                                                    endDate={this.state.quoteSearchForm?.date_range_end}
                                                    onSelectPeriod={(period, startDate, endDate) => {
                                                        this.setState({
                                                            quoteSearchForm: {
                                                                ...this.state.quoteSearchForm,
                                                                date_range: period,
                                                                date_range_start: startDate ? startDate : null,
                                                                date_range_end: endDate ? endDate : null,
                                                            },
                                                        });
                                                    }}
                                                    className="form-control-sm"
                                                    containerHeight="30px"
                                                    fontSize="93%"
                                                />
                                            </div>
                                        </div>
                                    </Ax>
                                )}
                            </div>
                            <div className="modal-footer">
                                <button type="button" className="btn btn-secondary" data-bs-dismiss="modal" onClick={this.poSearchClear}>Close</button>
                                <button type="submit" className="btn btn-primary">Search</button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        );
    };

    checkAllItem = () => {
        let allocationItemForCheckbox = document.getElementsByClassName('allocation_item_id_checkbox');
        if (allocationItemForCheckbox && allocationItemForCheckbox.length > 0) {
            for (let i = 0; i < allocationItemForCheckbox.length; i++) {
                allocationItemForCheckbox[i].checked = document.getElementById('all_check_allocation')?.checked;
            }
        }
    };

    render = () => {
        return (
            <ApplicationLayout>
                <Helmet><title>Asset Sales Order List</title></Helmet>
                {this.pageTitleBarJsx()}
                {this.horizontalAssetCardJsx()}
                {this.SalesOrderListJsx()}
                {this.quoteSearchModalJsx()}
            </ApplicationLayout>
        );
    };
}

const mapStateToProps = (state) => {
    return {
        access_token: state.auth.access_token,
        all_periods: state.app && state.app.all_periods ? state.app.all_periods : [],
        all_warehouses: state.app && state.app.warehouses ? state.app.warehouses : [],
        item_tags: state.app && state.app.item_tags ? state.app.item_tags : [],
        orgInfoData: state.app.group_info ? state.app.group_info : null,
        default_currency: state.app && state.app.default_currency ? state.app.default_currency : 'INR',
        permissions: state.app.acl_info && state.app.acl_info.permissions && state.app.acl_info.permissions.length > 0 ? state.app.acl_info.permissions : [],
    };
};

export default connect(mapStateToProps)(AssetSalesOrder);
